import { Translate } from '@dreryk/react-common';
import { StrongText, StyledFlex, Text } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../translations';

import { StyledText } from './PreInterviewPreviewItem.styled';
import { PreInterviewItem } from './PreInterviewPreviewItem.types';

type PreInterviewPreviewItemProps = Omit<PreInterviewItem, 'id'>;

export const PreInterviewPreviewItem = (props: PreInterviewPreviewItemProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={8}>
         <StrongText testId={'question'}>{`${props.questionNumber}. ${props.questionContent}`}</StrongText>
         {props.answerContent ? (
            <Text whiteSpaces={'break-spaces'} testId={'answer'}>
               {props.answerContent}
            </Text>
         ) : (
            <StyledText testId={'noAnswerContentPlaceholder'}>
               <Translate>
                  {appointmentsTranslationKeys.preInterview.modal.preview.noAnswerContentPlaceholder}
               </Translate>
            </StyledText>
         )}
      </StyledFlex>
   );
};
